import React,{useState,useEffect} from 'react';
import {Collapse,Navbar,NavbarBrand,Nav,NavItem} from 'reactstrap';
import {Link} from 'react-scroll';


const Header = () => {

    const [isOpen,setIsOpen] = useState(false);
    const [bg,setBg] = useState('bg-transparent');
    const toggle = () => setIsOpen(!isOpen);
    useEffect(() => {
      window.addEventListener('scroll',handleScroll);
    },[]);
    const handleScroll = () => {
       if(document.documentElement.scrollTop > 99 || document.body.scrollTop > 99){
          setBg('bg-dark');
       }else if(document.documentElement.scrollTop < 99 || document.body.scrollTop < 99){
           setBg('bg-transparent');
       }
    }

    return (
            <Navbar className={`fixed-top ` + bg} expand="md">
                <NavbarBrand href="/" className="navbar_brand">PowerScript</NavbarBrand>
                <button className="navbar-toggler" type="button" onClick={toggle} style={
                {border:'1px solid #fff',width:'50px',height:'50px'}}>
                <span className="navbar-toggler-icon" style={{background:'#fff',height:'1px',margin:'0px'}}></span>
                <span className="navbar-toggler-icon" style={{background:'#fff',height:'1px',margin:'0px'}}></span>
                </button>
                 <Collapse isOpen={isOpen} navbar>
                    <Nav className="ml-auto">

                        <NavItem>
                            <Link to="home" smooth={true} className="nav-link" duration={700} spy={true} offset={-50}>Home</Link>
                        </NavItem>
                        <NavItem>
                            <Link to="about" smooth={true} className="nav-link" duration={700} spy={true} offset={-50}>About</Link>
                            
                        </NavItem>
                        <NavItem>
                            <Link to="services" smooth={true} className="nav-link" duration={700} spy={true} offset={-50}>Services</Link>
                        </NavItem>
                        <NavItem>
                            <Link to="blog" smooth={true} className="nav-link" duration={700} spy={true} offset={-50}>Blog</Link>
                        </NavItem>

                    </Nav>
                 </Collapse>
            </Navbar>
    )
};


export default Header;